//@helpers
const { completeWithCharater } = require('utilities/ibanHelper');
const { APIPost  } = require('utilities/APIRequestHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
//@core
const apiURLBuilder = require('core/apiURLBuilder');

const getSecurityDataValid = (immSignaturePattern, immPrinter) => {
    let securityData = false;
    if (immSignaturePattern.get('requiredDigits')) {
        if(immSignaturePattern.get('consumerFinishInputDigits')){
            securityData = immSignaturePattern.get('consumerInputDigits').join(' ');
        }
    }else if (immSignaturePattern.get('requiredSMS')){
        if(immSignaturePattern.get('inputValueSMS').trim() && immSignaturePattern.get('isSMSValid')){
            securityData = immSignaturePattern.get('inputValueSMS');
        }
    }else if (isPrintOfficeMode()){
        securityData = immPrinter.get('documentsPrintedAndSigned') === 'YES';
    }

    return securityData;
};

const getIBANdata= (getState) =>{
    const { authorizeBizum, accounts} = getState();
    const destinationAccountId = authorizeBizum.getIn(['steps', '0', 'account']);
    const account = accounts.getIn(['byId', destinationAccountId]);
    const codbban =  account.getIn(['ibanComplex', 'codbban']);
    const codbbanCompleted = completeWithCharater(codbban);

    return {
        "codIBANCodbBan": codbbanCompleted,
        "codIBANDigitoControl": account.getIn(['ibanComplex', 'digitodecontrol']),
        "codIBANPais": account.getIn(['ibanComplex', 'pais']),
    };
}

const authorizeBizumRequest = (dispatch, getState, securityData, token) =>{
    const requestData = {};
    const query = Object.assign({"codigoOTP": securityData,"tokenFirma": token},getIBANdata(getState));
    requestData.query = query;

    return APIPost(dispatch, apiURLBuilder.getURL('bizumAuthorizeClient'), requestData);

}

const portabilityBizumRequest = (dispatch, getState) =>{
    const requestData = {};
    const { authorizeBizum, bizumConfirmation } = getState();
    const smsToken = bizumConfirmation.get("smsCode");
    const dataToken = authorizeBizum.get('authorizeBizumToken');
    const query = Object.assign({"codigoPortabilidad": smsToken,"tokenFirma": dataToken},getIBANdata(getState));

    requestData.query = query;

    return APIPost(dispatch, apiURLBuilder.getURL('bizumClientPortability'), requestData);
}

module.exports = {
    getSecurityDataValid,
    authorizeBizumRequest,
    portabilityBizumRequest
}
